import {Component, Input} from '@angular/core';
import {ArticlePrice} from "../../models/article-price.model";
import {ArticlePriceService} from "../../services/article-price.service";

@Component(
        {
            selector: 'app-shared-article-price-per-ordering-unit',
            templateUrl: './article-price-per-ordering-unit.component.html'
        }
)
export class ArticlePricePerOrderingUnitComponent {
    @Input() private values: {
        articlePrice?: ArticlePrice,
        hasTechnicalInsulationSegment: boolean,
        quantity: number,
    };

    constructor(
            private articlePriceService: ArticlePriceService
    ) {

    }

    get articlePrice() {
        return this.values.articlePrice;
    }

    get nettPriceInOrderingUnitOfMeasure() {
        return this.articlePriceService.getNettPriceInOrderingUnitOfMeasure(this.values.articlePrice, this.values.quantity);
    }

    get grossPriceInOrderingUnitOfMeasure() {
        return this.articlePriceService.getGrossPriceInOrderingUnitOfMeasure(this.values.articlePrice, this.values.quantity);
    }

    get hasTechnicalInsulationSegment() {
        return this.values.hasTechnicalInsulationSegment;
    }
}
